import {
  formatSizesBasic,
  formatSizesSocicalMedia,
  formatECommerce,
  formatBusiness,
  formatPrint,
  formatStandard,
} from '@/constants/format-sizes'
import { ResizeGroup } from './types'

export const LIST_RESIZE: ResizeGroup[] = [
  { Basic: formatSizesBasic },
  { 'Social media': formatSizesSocicalMedia },
  { 'E-commerce': formatECommerce },
  { Business: formatBusiness },
  { Print: formatPrint },
  { Standard: formatStandard },
]
